import { useEffect, useState } from 'react';
import './TicketsGrantedView.css';
import { useDispatch, useSelector } from 'react-redux';
import { UIRootState } from 'ui/store';
import { updateUIState } from 'ui/store/actions/gameUIActions';

export const TicketsGrantedView = () => {
    const dispatch = useDispatch();

    const [isVisible, setIsVisible] = useState(false);
    const state = useSelector((state: UIRootState) => state.gameUI);
    const grantedTickets = useSelector((state: UIRootState) => state.gameUI.modals.storiesModal.grantedTickets);

    useEffect(() => {
        if (grantedTickets) {
            setIsVisible(true);

            setTimeout(() => {
                dispatch(updateUIState({
                    ...state,
                    modals: {
                        ...state.modals,
                        storiesModal: {
                            ...state.modals.storiesModal,
                            grantedTickets: undefined
                        }
                    }
                }));
                setIsVisible(false);
            }, 2000);
        }
    }, [grantedTickets]);

    if (!isVisible) {
        return null;
    }

    return (
        <div className="h-100 w-100 d-flex justify-content-center align-items-center position-fixed bottom-0 start-0 tickets-granted-view">
            <div className={`d-flex flex-column align-items-center gap-2 tickets-granted-view-el ${isVisible ? 'tickets-granted-view__content' : ''}`}>
                <img src="/assets/stories/ticket.webp" alt="Tickets" style={{ width: '134px' }}/>
                <span>x{grantedTickets}</span>
            </div>
        </div>
    )
}